import { InvoicePaidByType } from '@seapoint/server/enums';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';

export type PaidInvoiceMatchingStatus =
  | 'Unknown'
  | 'Automatched'
  | 'Manually matched'
  | 'Paid via Seapoint'
  | 'No matched transaction'
  | 'Transaction removed';

export const getPaidInvoiceMatchingStatus = (
  isPaidUpdatedByType: InvoicePaidByType | undefined,
  hasTransactionId: boolean,
  hasTransactionObject: boolean,
): PaidInvoiceMatchingStatus => {
  if (!isPaidUpdatedByType) {
    return 'Unknown';
  }

  // If transaction was soft-deleted (pending transaction removed during sync)
  // We detect this when invoice has a transactionId but the transaction object is missing
  // This happens because soft-deleted transactions are excluded from backend API responses
  if (hasTransactionId && !hasTransactionObject) {
    return 'Transaction removed';
  }

  switch (isPaidUpdatedByType) {
    case InvoicePaidByType.SYSTEM:
      return 'Automatched';
    case InvoicePaidByType.USER:
      // If manually marked but no transaction, show different status
      return hasTransactionId ? 'Manually matched' : 'No matched transaction';
    case InvoicePaidByType.PAYMENT:
      return 'Paid via Seapoint';
    default:
      return exhaustiveCheck(isPaidUpdatedByType);
  }
};
